"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationVisitMotiveSelectionMode = exports.RegistrationFormField = exports.RegistrationRegionGroup = exports.RegistrationAgeGroup = exports.RegistrationGender = void 0;
var RegistrationGender;
(function (RegistrationGender) {
    RegistrationGender["MALE"] = "MALE";
    RegistrationGender["FEMALE"] = "FEMALE";
})(RegistrationGender || (exports.RegistrationGender = RegistrationGender = {}));
var RegistrationAgeGroup;
(function (RegistrationAgeGroup) {
    RegistrationAgeGroup["AGE_10_20"] = "AGE_10_20";
    RegistrationAgeGroup["AGE_30_40"] = "AGE_30_40";
    RegistrationAgeGroup["AGE_50_60"] = "AGE_50_60";
    RegistrationAgeGroup["AGE_70_PLUS"] = "AGE_70_PLUS";
})(RegistrationAgeGroup || (exports.RegistrationAgeGroup = RegistrationAgeGroup = {}));
var RegistrationRegionGroup;
(function (RegistrationRegionGroup) {
    RegistrationRegionGroup["CAPITAL_AREA"] = "CAPITAL_AREA";
    RegistrationRegionGroup["GANGWON"] = "GANGWON";
    RegistrationRegionGroup["CHUNGBUK_CHEONGJU"] = "CHUNGBUK_CHEONGJU";
    RegistrationRegionGroup["CHUNGNAM_DAEJEON"] = "CHUNGNAM_DAEJEON";
    RegistrationRegionGroup["CHUNGCHEONG"] = "CHUNGCHEONG";
    RegistrationRegionGroup["JEONBUK_JEONJU"] = "JEONBUK_JEONJU";
    RegistrationRegionGroup["JEONNAM_GWANGJU"] = "JEONNAM_GWANGJU";
    RegistrationRegionGroup["JEOLLA"] = "JEOLLA";
    RegistrationRegionGroup["GYEONGBUK_DAEGU"] = "GYEONGBUK_DAEGU";
    RegistrationRegionGroup["GYEONGNAM_CHANGWON"] = "GYEONGNAM_CHANGWON";
    RegistrationRegionGroup["BUSAN"] = "BUSAN";
    RegistrationRegionGroup["GYEONGSANG"] = "GYEONGSANG";
    RegistrationRegionGroup["JEJU"] = "JEJU";
    RegistrationRegionGroup["ETC_OVERSEAS"] = "ETC_OVERSEAS";
})(RegistrationRegionGroup || (exports.RegistrationRegionGroup = RegistrationRegionGroup = {}));
var RegistrationFormField;
(function (RegistrationFormField) {
    RegistrationFormField["GENDER"] = "gender";
    RegistrationFormField["AGE_GROUP"] = "ageGroup";
    RegistrationFormField["REGION_GROUP"] = "regionGroup";
    RegistrationFormField["VISIT_MOTIVES"] = "visitMotives";
})(RegistrationFormField || (exports.RegistrationFormField = RegistrationFormField = {}));
var RegistrationVisitMotiveSelectionMode;
(function (RegistrationVisitMotiveSelectionMode) {
    RegistrationVisitMotiveSelectionMode["SINGLE"] = "SINGLE";
    RegistrationVisitMotiveSelectionMode["MULTIPLE"] = "MULTIPLE";
})(RegistrationVisitMotiveSelectionMode || (exports.RegistrationVisitMotiveSelectionMode = RegistrationVisitMotiveSelectionMode = {}));
